import { ROLE } from "@/providers/AuthorizationProvider/types";
import { AuthorizationContext } from "@/providers/AuthorizationProvider/AuthorizationContext";
import { Path, useNavigate } from "@/router";
import { useLocation } from "react-router-dom";
import { useEffect, useContext } from "react";

function getUniversityId(universityLegacyIds: string[], hasRole: (role: ROLE) => boolean) {
  // Check if user has university staff role
  if (!hasRole(ROLE.UNIVERSITY_STAFF)) {
    return null;
  }

  if (universityLegacyIds.length === 0) {
    return null;
  }

  return universityLegacyIds[0];
}

function getActiveCallSearch(locationSearch: string): string {
  const params = new URLSearchParams(locationSearch);
  const activeCallParams = new URLSearchParams();

  ["activeCall", "activeCallEnded", "phone", "callSid"].forEach((paramName) => {
    const paramValue = params.get(paramName);
    if (paramValue) {
      activeCallParams.set(paramName, paramValue);
    }
  });

  return activeCallParams.toString();
}

export default function Index() {
  const navigate = useNavigate();
  const location = useLocation();
  const { loaded, universityLegacyIds, hasRole } = useContext(AuthorizationContext);

  useEffect(() => {
    // need the context to be loaded before we can check for university access
    if (!loaded) {
      return;
    }

    const universityId = getUniversityId(universityLegacyIds, hasRole);
    if (universityId) {
      navigate("/education/universities/:universityId/students" as Path, { params: { universityId }, replace: true });
    } else {
      const activeCallSearch = getActiveCallSearch(location.search);
      const staffLandingPath = hasRole(ROLE.PGA_MAGAZINE_STAFF) ? "/people" : "/home";

      // using `navigate` instead of `Loader->redirect` to prevent issue with infinite loop of redirects for unauthenticated users
      navigate((activeCallSearch ? `${staffLandingPath}?${activeCallSearch}` : staffLandingPath) as Path, {
        replace: true
      });
    }
  }, [loaded, universityLegacyIds, hasRole, navigate, location.search]);

  return null;
}
